import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CMPS_DIALOG_DATA, CmpsDialogRef } from '@cmps/ng-uikit';
import { TranslateService } from '@ngx-translate/core';

import { CoachingEventStatus } from '../../../../../../coaching-base/general';
import { WpCalculationType } from '../../../core';
import { SortOrder } from '../../../grid';
import { CommitmentDetailsDialogColumnId } from '../../model/commitment-details-dialog/commitment-details-dialog-column-id.model';
import { CommitmentDetailsDialogData } from '../../model/commitment-details-dialog/commitment-details-dialog-data.model';

import { TranslationKeyMap } from './commitment-details-dialog.component.i18n';
import { CommitmentDetailsSorter } from './commitment-details-sorter';

export const WpCalculationTypeToLabel = {
    [WpCalculationType.ACTUAL]: TranslationKeyMap._725_ACTUAL,
    [WpCalculationType.PERCENT_TO_TARGET]: TranslationKeyMap._768___TO_TARGET,
};

@Component({
    selector: 'cmps-wp-commitment-details-dialog',
    templateUrl: './commitment-details-dialog.component.html',
    host: {
        class: 'cmps-wp-commitment-details-dialog',
    },
})
export class CommitmentDetailsDialogComponent implements OnInit {
    /** @private */
    readonly _i18n = TranslationKeyMap;

    /** @private */
    readonly _CommitmentDetailsDialogColumnId = CommitmentDetailsDialogColumnId;

    /** @private */
    readonly _WpCalculationType = WpCalculationType;

    /** @private */
    readonly _WpCalculationTypeToLabel = WpCalculationTypeToLabel;

    /** @private */
    readonly _CoachingEventStatus = CoachingEventStatus;

    /** @private */
    readonly _SortOrder = SortOrder;

    /** @private */
    readonly _sorter: CommitmentDetailsSorter;

    constructor(
        private readonly _router: Router,
        private readonly _translateService: TranslateService,
        /** @private */ readonly _dialogRef: CmpsDialogRef<
            CommitmentDetailsDialogComponent,
            void
        >,
        @Inject(CMPS_DIALOG_DATA) /** @private */
        readonly _data: CommitmentDetailsDialogData,
    ) {
        this._sorter = new CommitmentDetailsSorter(this._translateService);
    }

    ngOnInit(): void {
        this._sorter.sortColumn(
            this._CommitmentDetailsDialogColumnId.DIRECT_REPORT,
            this._data.goalCommitments,
            SortOrder.DESC,
        );
    }

    /** @private */
    _onColumnSortClick(c: CommitmentDetailsDialogColumnId): void {
        this._sorter.sortColumn(c, this._data.goalCommitments, null);
    }

    /** @private */
    _onViewCommitmentClick(performerId: number, commitmentId: string): void {
        if (!Number.isInteger(parseInt(commitmentId))) {
            return;
        }
        const cmds = `coaching-detail/${performerId}/commitments/${commitmentId}`;
        this._dialogRef.close();
        void this._router.navigate([cmds]);
    }
}
